import React, { useContext, useEffect, useRef } from 'react';
import { Drawer as NextDrawer } from '@nextiva/next-ui-components';
import PropTypes from 'prop-types';

import { Snackbar } from 'components/Snackbar';
import { RootContext, actionTypes } from 'RootContext/rootContext';
import DrawerHeader from './DrawerHeader';
import styles from './Drawer.scss';

/**
 * @param {functon} toggleDrawer - callback to close the drawer from within
 */
const Drawer = ({ toggleDrawer, open, title, TitleComponent, children }) => {
  const {
    rootState: { hasWorkspaceError },
    rootDispatch,
  } = useContext(RootContext);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (hasWorkspaceError && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
      rootDispatch({ type: actionTypes.WORKSPACE_ERROR, payload: false });
    }
  }, [hasWorkspaceError]);

  return (
    <NextDrawer relentless open={open} anchor="right">
      <DrawerHeader
        title={title}
        toggleDrawer={toggleDrawer}
        TitleComponent={TitleComponent}
      />
      <div className={styles.contentContainer} ref={scrollContainerRef}>
        <Snackbar isDrawer />
        {children}
      </div>
    </NextDrawer>
  );
};

Drawer.propTypes = {
  TitleComponent: PropTypes.oneOfType([PropTypes.bool, PropTypes.elementType]),
  open: PropTypes.bool,
  title: PropTypes.string,
  toggleDrawer: PropTypes.func,
};

export default Drawer;
